import React, { Component } from "react"
import { withStyles } from "@material-ui/core"
import * as constants from "../constants"
import { Cookies } from "react-cookie"
import Grid from "@material-ui/core/Grid"
import Divider from "@material-ui/core/Divider"
import FloatingLabelInput from "./FloatingLabelInput"
import Select from "react-select"
import Button from "@material-ui/core/Button"
import Fab from "@material-ui/core/Fab"
import EditIcon from "@material-ui/icons/Edit"
import DeleteIcon from "@material-ui/icons/Delete"
import Snackbar from "@material-ui/core/Snackbar"
import { Alert, AlertTitle } from "@material-ui/lab"

const styles = (theme) => ({
      button: {
            margin: theme.spacing.unit,
      },
      small: {
            width: theme.spacing(6),
            height: theme.spacing(6),
      },
})

class ElevatorPriceKind extends Component {
      cookies = new Cookies()
      constructor(props) {
            super(props)

            this.state = {
                  PriceKindState: this.props.elevatorPriceKind,

                  selectedElevatorKind: {
                        value: this.props.elevatorPriceKind.elevator_price_kind_elevator_kind_id,
                        label: this.props.elevatorPriceKind.elevator_kind_name,
                  },
                  visible: true,
                  snackstr: "",
                  showSnack: false,
                  snackMode: "success",
                  optionElevatorKind: [],
            }
      }
      componentDidMount() {
            this.getoptionElevatorKind()
      }



      getoptionElevatorKind = () => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              var Company = []
                              for (var k = 0; k < arr.data.length; k++) {
                                    Company.push({ value: arr.data[k].elevator_kind_id, label: arr.data[k].elevator_kind_name })
                              }
                              self.setState({ optionElevatorKind: Company }, () => {})
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_elevator_kind")
            xhttp.open("POST", `${constants.BASE_URL}/elevator`)
            xhttp.send(fd)
      }

      handleClickcloseTasckBar = (event) => {
            this.setState({ showSnack: false })
      }



      handleElevatorKind  = (selectedElevatorKind) => {
            var temparray = this.state.PriceKindState
            temparray.elevator_price_kind_elevator_kind_id = selectedElevatorKind.value
            this.setState({ selectedElevatorKind: selectedElevatorKind, PriceKindState: temparray })
      }

      handleChangeKindPercent = (event) => {
            var temparray = this.state.PriceKindState
            temparray.elevator_price_kind_percent = event
            this.setState({ PriceKindState: temparray })
      }



      modifyNewInstalmentCondition = () => {
            const { PriceKindState } = this.state

            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        console.log(this.responseText)
                        var arr = JSON.parse(this.responseText)
                        console.log(arr)
                        if (arr.result === "ok") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "modify_price_kind")
            fd.append("elevator_price_kind_id", PriceKindState.elevator_price_kind_id)
            fd.append("elevator_price_kind_elevator_kind_id", PriceKindState.elevator_price_kind_elevator_kind_id)
            fd.append("elevator_price_kind_percent", PriceKindState.elevator_price_kind_percent)

            xhttp.open("POST", `${constants.BASE_URL}/elevator`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }

      deleteInstalmentCondition = () => {
            const { PriceKindState } = this.state

            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        console.log(arr)
                        if (arr.result === "ok") {
                              self.setState({ visible: false, snackstr: arr.desc, showSnack: true, snackMode: "success" })
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "delete_price_kind")
            fd.append("elevator_price_kind_id", PriceKindState.elevator_price_kind_id)

            xhttp.open("POST", `${constants.BASE_URL}/elevator`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }

      render() {
            const { classes } = this.props
            const { optionElevatorKind , snackMode, snackstr, showSnack, visible , selectedElevatorKind, PriceKindState } = this.state
            if (visible) {
                  return (
                        <Grid container spacing={3}>
                              <Snackbar
                                    anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                                    onClose={this.handleClickcloseTasckBar}
                                    open={showSnack}
                                    autoHideDuration={10000}
                              >
                                    <Alert severity={snackMode}>{snackstr}</Alert>
                              </Snackbar>

                              <Grid item xs={4}>
                                    <div>
                                          <label className="on">نوع اسانسور </label>
                                          <Select
                                                isSearchable={true}
                                                className="adapter-txtsize"
                                                placeholder={"نوع اسانسور"}
                                                value={selectedElevatorKind}
                                                onChange={this.handleElevatorKind }
                                                options={optionElevatorKind}
                                          />
                                    </div>
                              </Grid>





                              <Grid item xs={4}>
                                    <FloatingLabelInput
                                        type="percent"
                                        placeholder="درصد اضافه نرخ"
                                        handleInputt={this.handleChangeKindPercent}
                                        value={PriceKindState.elevator_price_kind_percent}
                                    />
                              </Grid>

                              <Grid item xs={4}>
                                    <div style={{ width: "100%", textAlign: "left" }}>
                                          <Fab
                                                className={classes.small}
                                                style={{ background: "#44b700" }}
                                                aria-label="edit"
                                                onClick={this.modifyNewInstalmentCondition}
                                          >
                                                <EditIcon />
                                          </Fab>

                                          <Fab className={classes.small} color="secondary" aria-label="edit" onClick={this.deleteInstalmentCondition}>
                                                <DeleteIcon />
                                          </Fab>
                                    </div>
                              </Grid>
                              <Grid item xs={12}>
                                    <Divider />
                              </Grid>
                        </Grid>
                  )
            } else {
                  return null
            }
      }
}
export default withStyles(styles)(ElevatorPriceKind)
